import { DeviceTypeEnum } from '@rmc/webcx-web-libs';
import { getNativeRcxCookie } from '../../lib/Cookies/RcxCookie';
import { getNativeRzCookie } from '../../lib/Cookies/RzCookie';
import { getNativeRcxGlobalCookie } from '../../lib/Cookies/RcxGlobalCookie';
import { ClickTypeEnum } from '../../types/clickType.d';

const MOBILE_SCREEN_MAX_WIDTH = 768;

function isScreenMobile() {
	return window.innerWidth <= MOBILE_SCREEN_MAX_WIDTH;
}

export function getLocation() {
	return window.location.href;
}

export function getDevice(): string {
	const isMobile = isScreenMobile();
	return isMobile ? DeviceTypeEnum.MOBILE : DeviceTypeEnum.DESKTOP;
}

export function getMainAppInfo() {
	return {
		device: getDevice(),
		location: getLocation(),
		sessionId: getNativeRcxCookie(),
		domainScopedSessionId: getNativeRcxGlobalCookie(),
		userId: getNativeRzCookie(),
		isMobile: isScreenMobile(),
	};
}

export function getType(type?: ClickTypeEnum) {
	switch (type) {
		case 'button':
			return 'CLICK_ACTION_BUTTON';
			break;
		case 'image':
			return 'CLICK_IMAGE';
			break;
		default:
			return 'CLICK_LINK';
			break;
	}
}

export function getAction(eventType: string, type?: ClickTypeEnum) {
	switch (eventType) {
		case 'click':
			return getType(type);
			break;
		case 'close':
			return 'CLOSE';
			break;
		default:
			return 'DISPLAY';
			break;
	}
}
